import React, { useState, useEffect, useCallback } from 'react';
import { useSpring } from 'react-spring';
import { Button } from '../../components/Button';
import * as Ui from './styles';

// TODO: documentar
function PromptConfirm({
  // informa que o prompt está sendo visível ou não
  isOpen = false,
  // informa que está ocorrendo um processamento e o botão Ok deve refletir isto como microinteração
  isLoading = false,
  // um dos componentes de ícones
  iconComponent,
  // tamanho do ícone
  iconSize = 30,
  // o texto a ser exibito
  text,
  // evento de acionamento do botão de encerramento ou TODO: de toque fora da tela ou ESC
  onClose,
  // evento de acionamento do botão de confirmação
  onConfirm,
}) {
  // state
  const [isVisible, setVisibility] = useState(false);

  // callbacks
  const handleExitByDOMEvent = useCallback((event) => {
    if (event.keyCode === 27) {
      setVisibility(false);
    }
  }, []);

  // on open or close
  useEffect(() => {
    setVisibility(isOpen);
  }, [isOpen]);

  // change body style
  useEffect(() => {
    document.addEventListener('keydown', handleExitByDOMEvent, false);
    return () => {
      document.removeEventListener('keydown', handleExitByDOMEvent, false);
    };
  });

  // animation
  const animationProps = useSpring({
    from: {
      opacity: isVisible ? 0 : 1,
    },
    to: {
      opacity: isVisible ? 1 : 0,
    },
    onStart: () => {
      if (isVisible) setVisibility(true);
    },
    onRest: () => {
      if (!isVisible) setVisibility(false);
    },
  });

  // handle reset state
  function handleCancel() {
    setVisibility(false);
    if (onClose) onClose();
  }

  // handle accepted file
  function handleOk() {
    if (onConfirm) onConfirm();
    setVisibility(false);
  }

  //
  function renderBody() {
    //
    const Icon = (props) => iconComponent(props);
    //
    return (
      <Ui.BodyContent>
        <Ui.IconContentPart>
          <Icon size={iconSize} />
        </Ui.IconContentPart>
        <Ui.TextContentPart>
          {text}
        </Ui.TextContentPart>
      </Ui.BodyContent>
    );
  }

  // conditional render
  if (!isVisible) {
    return null;
  }

  return (
    <Ui.Container style={{ ...animationProps, visibility: isVisible ? 'visible' : 'hidden' }}>
      <Ui.Panel>
        <Ui.Body>
          {renderBody()}
        </Ui.Body>
        <Ui.Actions>
          <Button type="button" title={'Voltar'} loading={isLoading} onClick={() => handleCancel()} className="negative" clear />
          {!isLoading ? (
            <Button type="button" title={'Sim'} loading={isLoading} onClick={() => handleOk()} />
          ) : null}
        </Ui.Actions>
      </Ui.Panel>
    </Ui.Container>
  );
}

// create an hooker to handle PromptConfirm
const usePromptConfirm = (() => {
  // states
  const [isOpen, setIsOpen] = useState(false);
  const [onConfirm, setOnConfirm] = useState(null);
  const [onClose, setOnClose] = useState(null);

  const openPromptConfirm = useCallback((openCallback, closeCallback) => {
    setIsOpen(true);
    if (openCallback) setOnConfirm(() => openCallback);
    if (closeCallback) setOnClose(() => closeCallback);
  }, []);

  const handleClose = useCallback(() => {
    if (onClose) {
      onClose();
    }
    setIsOpen(false);
  }, [onClose]);

  const handleConfirm = useCallback(() => {
    if (onConfirm) {
      onConfirm();
    }
    setIsOpen(false);
  }, [onConfirm]);

  function renderPromptConfirm(icon, text) {
    return (
      <PromptConfirm
        isOpen={isOpen}
        iconComponent={icon}
        text={text}
        onClose={handleClose}
        onConfirm={handleConfirm}
      />
    );
  }

  return [
    openPromptConfirm,
    renderPromptConfirm,
  ];
});

export { PromptConfirm, usePromptConfirm };
